import { render, staticRenderFns } from "./addHklr.vue?vue&type=template&id=307e8607"
import script from "./addHklr.vue?vue&type=script&lang=js"
export * from "./addHklr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports